module.exports = __webpack_public_path__ + "static/media/logo-text.86fcbfa5.svg";